module.exports = __webpack_public_path__ + "static/media/t1.b5af6004.pdf";